<div
  class="accordion-wrapper"
  *ngIf="isOpen || keepContentVisible"
  [@containerSlide]="isOpen"
  (@containerSlide.done)="onContainerSlideDone($event)"
>
  <ng-content></ng-content>
</div>
